import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, naira } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Loader2, Printer, ArrowLeft } from "lucide-react";

const FOUNDATION_LOGO = "/brand/somkene-odabi-foundation.png";

export default function ImpactCard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dash, setDash] = useState(null);
  useEffect(() => { api.get("/sponsors/dashboard").then((r) => setDash(r.data)).catch(() => setDash({ metrics: {} })); }, []);

  if (!dash) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-emerald-600" /></div>;
  const m = dash.metrics || {};
  const stats = [
    ["Beneficiaries Funded", (m.total_beneficiaries || 0).toLocaleString()],
    ["Total Allocation", naira(m.total_allocation || 0)],
    ["Benefits Redeemed", naira(m.redeemed || 0)],
    ["Redemption Rate", `${m.redemption_rate || 0}%`],
    ["Vendors Participating", (m.vendors_participating || 0).toLocaleString()],
    ["States Covered", (m.states_covered || 0).toLocaleString()],
    ["Total Transactions", (m.total_transactions || 0).toLocaleString()],
    ["Economic Activity", naira(m.total_economic_activity || 0)],
  ];

  return (
    <div className="min-h-screen bg-emerald-50/60 py-8 px-4">
      <style>{`@media print { .no-print { display:none !important; } body { background:#fff; } }`}</style>
      <div className="max-w-3xl mx-auto">
        <div className="no-print flex items-center justify-between mb-5">
          <button onClick={() => navigate("/sponsor")} className="text-emerald-700 flex items-center gap-2 text-sm"><ArrowLeft className="w-4 h-4" /> Back to Dashboard</button>
          <Button data-testid="impact-card-print-btn" onClick={() => window.print()} className="bg-emerald-600 hover:bg-emerald-700 rounded-full"><Printer className="w-4 h-4 mr-2" /> Download / Print</Button>
        </div>

        <div data-testid="impact-card" className="rounded-3xl bg-white border border-emerald-100 shadow-sm overflow-hidden">
          <div className="bg-emerald-950 tmf-grain px-8 py-7 flex items-center justify-between">
            <div>
              <div className="text-[10px] font-mono uppercase tracking-widest text-emerald-300">TMF Impact Snapshot</div>
              <h1 className="mt-1 font-display font-extrabold text-2xl text-white">{user?.name || "Sponsor"}</h1>
              <p className="text-emerald-200/80 text-xs mt-1">Generated {new Date().toLocaleDateString()}</p>
            </div>
            <div className="rounded-xl bg-white p-1.5"><img src={FOUNDATION_LOGO} alt="TMF" className="h-14 w-14 object-contain" /></div>
          </div>
          <div className="p-8">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
              {stats.map(([k, v]) => (
                <div key={k} className="rounded-2xl border border-emerald-100 p-4">
                  <div className="text-[11px] text-gray-500">{k}</div>
                  <div className="mt-1 font-display font-bold text-lg text-emerald-950 tabular-nums">{v}</div>
                </div>
              ))}
            </div>
            <p className="mt-8 font-display font-bold tracking-wide text-emerald-700 text-center">FOOD. ACCESS. DIGNITY. CHOICE.</p>
            <p className="mt-2 text-center text-xs text-gray-400">Powered by Text-Me-Food · A Somkene Odabi Foundation initiative</p>
          </div>
        </div>
      </div>
    </div>
  );
}
